import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { twinPreparePrice } from '../../../../../../utils/globals/price'
import { SpecificPriceRulesDict } from '../../../../../../utils/reducers/products/specificPriceRules'
import { ProductExtendedTyShort } from '../../../../types'
import { EditVariantPricesTy, ProductVariantsPrepared } from './types'


export const parseVariantsToSpecificPriceRules = (specificPriceRules: SpecificPriceRulesDict, products: ProductExtendedTyShort[]) => {
    const specificPriceProducts: TwinDictionary = {}
    const result: EditVariantPricesTy = {}
    for (const product of products) {
        if (product.SpecificPricesProduct?.length) {
            for (const priceProduct of product.SpecificPricesProduct) {
                if (!specificPriceProducts[priceProduct.SpecificPriceRuleId]) {
                    specificPriceProducts[priceProduct.SpecificPriceRuleId] = {}
                }
                if (!specificPriceProducts[priceProduct.SpecificPriceRuleId][priceProduct.ProductId]) {
                    specificPriceProducts[priceProduct.SpecificPriceRuleId][priceProduct.ProductId] = {}
                }
                specificPriceProducts[priceProduct.SpecificPriceRuleId][priceProduct.ProductId][priceProduct.units] = {
                    ...priceProduct,
                }
            }
        }
        if (!result[product.id]) {
            result[product.id] = {
                dataProduct: {
                    ...product,
                    reference: product.reference || '',
                    ProductId: product.id,
                    Product: product,
                },
                prices: []
            }
        }
        for (const key in specificPriceRules) {
            const element = specificPriceRules[key]
            if (specificPriceProducts?.[element.id]?.[product.id]) {
                for (const key in specificPriceProducts?.[element.id]?.[product.id]) {
                    const subElement = specificPriceProducts?.[element.id]?.[product.id][key]
                    result[product.id].prices.push({
                        ...element,
                        price: '',
                        _old_price: subElement.calculated_price,
                        units: 1,
                        SpecificPriceRule: element,
                        SpecificPriceRuleId: element.id,
                        ...subElement
                    })
                }
            } else {
                result[product.id].prices.push({
                    ...element,
                    price: '',
                    units: 1,
                    ProductId: product.id,
                    Product: product,
                    SpecificPriceRule: element,
                    SpecificPriceRuleId: element.id,
                })
            }
        }
        result[product.id].prices  = twinPreparePrice(result[product.id].prices as any) as any
    }
    return result
}


export const getVariantPreparedFromProducts = (products: ProductExtendedTyShort[]) => {
    const langs = []
    const variantsPrepared: ProductVariantsPrepared = []
    let langObj = {}
    for (const element of products) {
        if (element.ProductLangs.length) {
            for (const myLang of element.ProductLangs) {
                langs.push({[myLang.LangId]: myLang.name})
            }
            for (const item of langs) {
                langObj = { ...langObj, ...item };
            }
        }
        variantsPrepared.push({
            code_bar: element.code_bar || '',
            name: langObj,
            id: element.id,
            reference: element.reference || ''
        })
    }
    return variantsPrepared
}